import script from "./ContentSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./ContentSidebar.vue?vue&type=style&index=0&id=86113130&lang=scss&scoped=true"
import "./ContentSidebar.vue?vue&type=style&index=1&id=86113130&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86113130"]])

export default __exports__